import React from 'react'
import { Typography } from '@mui/material'
import SectionCollapse from '../../../../../section/SectionCollapse'

const UnitsOfLearning = ({ items = [] }) => {
  return (
    <SectionCollapse title={`Unit of learning (#${items?.length})`}>
      { items.length > 0 ?
        <div className='grid grid-cols-4 gap-2'>
        { items.map((item, index) => (
          <div id={`${item._id}-${index}`}>{item.name}</div>
        ))}
        </div>
        :
        <Typography className='text-muted-foreground opacity-50'>You don't have any units of learning yet</Typography>
      }
    </SectionCollapse>
  )
}

export default UnitsOfLearning